module.exports = __webpack_public_path__ + "static/insect_plague-ca3de260b30faf8b48dbe911a384503c.jpg";